import { request } from '../http';

/** 当前前端项目标识，读写发版时间时需保持一致 */
export const FRONTEND_RELEASE_PROJECT = 'coop-website';

/**
 * 读取前端发版时间
 * @param {object} [options]
 * @param {string} [options.project] 项目标识；不传/空字符串走后端默认全局记录
 */
export function getFrontendReleaseTime(options = {}) {
  const { project } = options;
  const params = {};

  if (project) {
    params.project = project;
  }

  return request('/api/frontend-release-time', {
    method: 'get',
    params,
    // 发版检查失败不应触发登出/刷新 token，避免与 user_info 等鉴权请求竞态
    silentError: true
  });
}
